module.exports = __webpack_public_path__ + "img/gongsi.cd428614.png";